import styled from 'styled-components';
import Radio from 'components/shared/inputs/radio/RadioInput';

const StyledRadio = styled(Radio)`
    grid-area: 'radio';
`;

export default StyledRadio;
